import {
  Alert,
  Autocomplete,
  Chip,
  Dialog,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomButton from "../../../reusableComponents/CustomButton";
import "../Notification Logs/webhooks.css";
import { useAuth } from "../../../context/API_Client";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import CreateApiIcon from "../../../../assets/svg/createApiIcon.svg";
import { fileCopyDefaultColor } from "../../../reusableComponents/constants";
import { colorBrandObject } from "../../../../constants/brandings";
function CreateApiKey({
  open,
  onClose,
  text,
  setText,
  handleBusinessUnitForPayload,
}) {
  const { postPspConfigForFiltering } = useAuth();

  const [localText, setLocalText] = useState(text);
  const [disableButton, setDisableButton] = useState(true);
  const [businessUnitsData, setBusinessUnitsData] = useState("");
  const [selectedBusinessUnits, setSelectedBusinessUnits] = useState([]);
  const loginUser = localStorage?.getItem("userDetails");
  const userObject = JSON.parse(loginUser);
  const handleSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
    setText(localText);
    handleBusinessUnitForPayload(selectedBusinessUnits);
    setLocalText("");
    onClose();
  };

  useEffect(() => {
    if (
      (userObject?.businessUnits?.length &&
        selectedBusinessUnits?.length === 0) ||
      localText?.length === 0
    ) {
      setDisableButton(true);
    } else {
      setDisableButton(false);
    }
  }, [selectedBusinessUnits, userObject, localText]);

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      setLocalText("");
      onClose();
    }
  };
  useEffect(() => {
    postPspConfigForFiltering(
      {},
      function (data) {
        setBusinessUnitsData(data?.legalEntities);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  const handleBusinessUnit = (event, value) => {
    const selectedCodes = value.map((option) => option.code);
    setSelectedBusinessUnits(selectedCodes);
  };

  const handleCross = () => {
    onClose();
    setLocalText()
  }

  return (
    <Dialog className="apikeyModal" open={open} onKeyDown={handleKeyDown}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "12px",
          padding: "24px 24px 0px 24px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <CreateApiIcon stroke={`${colorBrandObject?.primaryButtonColor}`}
            style={{ marginTop: "8px", cursor: "pointer" }}
          />
          <Typography className="SemiboldTwenty font-black-highest">
            Generate API Key
          </Typography>
        </div>
        <img
          src="/assets/close-modal-cross.svg"
          style={{ height: "16px", width: "16px", cursor: "pointer" }}
          alt="cross"
          onClick={() => handleCross()}
        />
      </div>

      <Typography
        className="labelRegular font-black-high"
        style={{ padding: "0px 24px" }}
      >
        Extend invitations to your team members, granting them access to
        BoxPay's collaborative dashboard
      </Typography>

      <div
        style={{
          padding: "0px 24px",
        }}
      >
        <div
          style={{
            margin: "20px 0px",
          }}
        >
          <div>
            <Typography className="bodyB2Medium apiKeyHeading">
              Key Name*
            </Typography>
            <OutlinedInput
              size="small"
              placeholder="Enter Key Name"
              value={localText}
              onChange={(e) => setLocalText(e.target.value)}
              inputProps={{ maxLength: 20 }}
              aria-describedby="outlined-title-helper-text"
              style={{ width: "100%", marginTop: "8px" }}
            />
          </div>

          <div
            style={{ margin: "20px 0px 40px 0px" }}
            className="multiselectInput"
          >
            <Typography className="bodyB2Medium apiKeyHeading">
              Business Unit(s) {userObject?.businessUnits && "*"}
            </Typography>
            <Autocomplete
              multiple
              limitTags={1}
              options={businessUnitsData}
              getOptionLabel={(option) => option.name}
              className="multiselect"
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={
                    selectedBusinessUnits.length === 0
                      ? "Select Business Unit"
                      : ""
                  }
                />
              )}
              onChange={handleBusinessUnit}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    key={index}
                    label={option.name}
                    {...getTagProps({ index })}
                    style={{
                      maxWidth: 250,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  />
                ))
              }
            />
          </div>
        </div>
        <div
          style={{
            margin: "0px 0px 40px 0px",
          }}
        >
          <Alert
            sx={{
              border: "1px solid var(--Global-Squash-300, #FFE9BA)",
              background: "#FFF6DA",
              boxShadow: "0px 1.5px 4px -1px rgba(10, 9, 11, 0.07)",
              padding: 1,
            }}
            icon={false}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "4px",
              }}
            >
              <img src="/assets/info-circle-yellow.svg" style={{ marginTop: "4px" }} />

              <div>
                <Typography className="alertHeading">
                  Security Advice
                </Typography>
                <Typography
                  style={{
                    color: " var(--Global-Neutral-Grey-1300, #0A090B)",
                    fontSize: "12px",
                    fontWeight: 400,
                  }}
                >
                  You are solely responsible for maintaining adequate security
                  and control of any API Keys issued to you by BoxPay. You are
                  required to encrypt your API Keys in all storage and
                  communication
                </Typography>
              </div>
            </div>
          </Alert>
        </div>
      </div>
      <div
        style={{
          paddingBottom: "24px",
          paddingTop: "24px",
          paddingRight: "24px",
          display: "flex",
          justifyContent: "end",
          boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
        }}
      >
        <CustomButton
          variant={"contained"}
          size={"md"}
          type={"secondary"}
          text={"Done"}
          disabled={disableButton}
          onClick={handleSubmit}
        />
      </div>
    </Dialog>
  );
}

export default CreateApiKey;
